export default (initialState = {}) => {
  return () => {
    return {
      billing_address: "",
      buyer_name: "",
      buyer_gstin: "",
      date: new Date(),
      files: [],
      invc_id: {
        billing_address: "",
        shipping_address: "",
      },
      invc_date: null,
      invc_number: "",
      lineitems: [],
      number: "",
      payment_terms: "",
      po_id: {
        payment_terms: "",
      },
      po_info: {},
      remarks: "",
      shipping_address: "",
      status: "Active",
      total_amount: null,
      total_tax: null,
      ...initialState,
    };
  };
};
